// 会被编译到本app.js中的组件
const components = {
    'index': require('../views/index.vue').default,
    'customization': require('../views/product/customization.vue').default,
    'index2': require('../views/product/index.vue').default,
    'acustLoginPay': require('../views/agent/acustLoginPay.vue').default,
    'custIndex': require('../views/product/custIndex.vue').default,
    'custLogin': require('../views/product/custLogin.vue').default,
    'custQues': require('../views/product/custQues.vue').default,
    'freeLogin': require('../views/product/freeLogin.vue').default,
    'freeQues': require('../views/product/freeQues.vue').default,
    'general': require('../views/product/general.vue').default,
    'official': require('../views/product/official.vue').default,
    'pay': require('../views/pay/index.vue').default,
    'question': require('../views/product/question.vue').default,
    'result': require('../views/pay/result.vue').default,
    'wxres': require('../views/pay/wxres.vue').default,
    'shop': require('../views/shop/index.vue').default,
    'shopFree': require('../views/shop/free.vue').default,
    'questionNew': require('../views/product/questionNew.vue').default
}
export default components


// WEBPACK FOOTER //
// ./src/router/components.js